export type ThemeAccentId = "purple" | "pink" | "blue" | "green" | "orange";

type AccentSpec = {
  primary: string;
  primaryLight: string;
  primaryDark: string;
  accent: string;
  info: string;
};

const ACCENT_SPECS: Record<ThemeAccentId, AccentSpec> = {
  purple: {
    primary: "#4614BB",
    primaryLight: "#6D3DD8",
    primaryDark: "#2E0D7A",
    accent: "#8B5CF6",
    info: "#5F33E1",
  },
  pink: {
    primary: "#DB2777",
    primaryLight: "#EC4899",
    primaryDark: "#9F1239",
    accent: "#F472B6",
    info: "#DB2777",
  },
  blue: {
    primary: "#4A2BB8",
    primaryLight: "#5F33E1",
    primaryDark: "#3D1F95",
    accent: "#7C4DFF",
    info: "#5F33E1",
  },
  green: {
    primary: "#059669",
    primaryLight: "#10B981",
    primaryDark: "#047857",
    accent: "#34D399",
    info: "#059669",
  },
  orange: {
    primary: "#D97706",
    primaryLight: "#F59E0B",
    primaryDark: "#B45309",
    accent: "#FBBF24",
    info: "#D97706",
  },
};

const DARK_ACCENT_SPECS: Record<ThemeAccentId, AccentSpec> = {
  purple: {
    primary: "#A78BFA",
    primaryLight: "#C4B5FD",
    primaryDark: "#8B5FE8",
    accent: "#C4B5FD",
    info: "#9A7AFF",
  },
  pink: {
    primary: "#F472B6",
    primaryLight: "#F9A8D4",
    primaryDark: "#EC4899",
    accent: "#FBCFE8",
    info: "#F472B6",
  },
  blue: {
    primary: "#9A7AFF",
    primaryLight: "#C4B5FD",
    primaryDark: "#7C4DFF",
    accent: "#C4B5FD",
    info: "#9A7AFF",
  },
  green: {
    primary: "#34D399",
    primaryLight: "#6EE7B7",
    primaryDark: "#10B981",
    accent: "#A7F3D0",
    info: "#34D399",
  },
  orange: {
    primary: "#FBBF24",
    primaryLight: "#FCD34D",
    primaryDark: "#F59E0B",
    accent: "#FDE68A",
    info: "#FBBF24",
  },
};

export function getAccentThemeOverrides(
  accentId: ThemeAccentId,
  isDarkMode: boolean
): Partial<AccentSpec> {
  const spec = isDarkMode
    ? DARK_ACCENT_SPECS[accentId]
    : ACCENT_SPECS[accentId];
  return spec;
}

export function getAccentGradient(accentId: ThemeAccentId): string[] {
  const spec = ACCENT_SPECS[accentId];
  return [spec.primaryDark, spec.primary, spec.primaryLight];
}

export const THEME_ACCENT_OPTIONS: { id: ThemeAccentId; label: string }[] = [
  { id: "purple", label: "Roxo" },
  { id: "pink", label: "Rosa" },
  { id: "blue", label: "Azul" },
  { id: "green", label: "Verde" },
  { id: "orange", label: "Laranja" },
];
